/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react'

import { Rnd } from 'react-rnd'
import { CloseCircleFilled } from '@ant-design/icons'
import { VArrow, HArrow } from './Arrows'
import { useIsSmallDevice } from '../../hookreducer/hooks'

export const Item = ({
  id, x, y, width, height, image, zIndex, selectElement,
  isSelected, removeElement, isTagged, setItemPosition,
  res, baseRes, realWidth, realDepth, realDiameter, isQuotes,
  collision, realWidthBase, realHeightBase,
}) => {
  const isSmall = useIsSmallDevice()
  const factor = res / baseRes
  const style = {
    backgroundImage: `url("${image}")`,
    boxSizing: 'border-box',
    zIndex: zIndex || Math.floor(1200 - y + x),
    border: isTagged ? '1px solid #385623' : null,
    backgroundColor: collision ? 'rgba(215,91,71,0.2)' : isSelected ? 'rgba(240,240,240,0.4)' : 'transparent',
    backgroundRepeat: 'no-repeat',
  }

  const dimension = realWidthBase && realHeightBase ? null // `${realWidthBase}x${realHeightBase}cm`
    : realWidth && realDepth ? `L.${realWidth} x p.${realDepth}cm`
      : realWidth ? `${realWidth}cm`
        : realDepth ? `p.${realDepth}cm`
          : realDiameter ? `⌀${realDiameter}cm`
            : ''

  return (
    <Rnd
      bounds="parent"
      className="item"
      style={style}
      position={{
        x: x / factor,
        y: y / factor,
      }}
      size={{
        width: width / factor,
        height: height / factor,
      }}
      enableResizing={false}
      dragGrid={[1, 1]}
      onDragStop={(evt, newPosition) => {
        setItemPosition(
          id,
          { lastX: Math.round(newPosition.lastX), lastY: Math.round(newPosition.lastY) },
        )
      }}
    >
      <div
        style={{ width: '100%', height: '100%' }}
        onClick={(evt) => {
          evt.stopPropagation()
          selectElement(id)
        }}
        onTouchStart={(evt) => {
          evt.stopPropagation()
          selectElement(id)
        }}
      >


        <div
          style={{
            visibility: isSelected ? 'visible' : 'hidden',
            position: 'absolute',
            top: 0,
            right: 0,
            fontSize: '1.4em',
            cursor: 'default',
            lineHeight: '16px',
            display: isSmall ? 'none' : 'block',
          }}
          onClick={(evt) => { evt.stopPropagation(); removeElement(id) }}
          onTouchStart={(evt) => { evt.stopPropagation(); removeElement(id) }}
        >

          <CloseCircleFilled />
        </div>

        <div
          style={{
            visibility: isQuotes ? 'visible' : 'hidden',
            position: 'absolute',
            bottom: '-1.3em',
            width: '100%',
            textAlign: 'center',
            fontSize: '0.8em',
          }}
          onClick={(evt) => { evt.stopPropagation(); removeElement(id) }}
        >
          {dimension}
        </div>
      </div>
    </Rnd>
  )
}

export const PlaceHolder = ({
  id, x, y, width, height, boxName, boxType, view, viewQuotes,
  selectElement, isSelected, removeElement, isTagged, setItemPosition,
  res, baseRes, realWidth, realHeight,
}) => {
  const factor = res / baseRes
  const isObstacle = boxType === 'block'
  const isArrow = boxType === 'vArrow' || boxType === 'hArrow'
  const style = {
    visibility: view ? 'visible' : 'hidden',
    border: isTagged && !isArrow ? '1px solid blue' : !isArrow ? '1px solid black' : null,
    backgroundColor: isObstacle ? 'black' : 'transparent',
    backgroundImage: isObstacle ? 'repeating-linear-gradient(45deg, transparent, transparent 1px, rgba(255,255,255) 1px, rgba(255,255,255) 4px)' : null,
  }

  const dimension = realWidth && realHeight ? `${boxName || ''} ${realWidth}x${realHeight}cm` : ''

  return (
    <Rnd
      onClick={(evt) => {
        evt.stopPropagation()
        selectElement(id)
      }}
      bounds="parent"
      className="item"
      style={style}
      position={{
        x: x / factor,
        y: y / factor,
      }}
      size={{
        width: width / factor,
        height: height / factor,
      }}
      enableResizing={false}
      onDragStop={(evt, newPosition) => {
        setItemPosition(
          id,
          { lastX: Math.round(newPosition.lastX), lastY: Math.round(newPosition.lastY) },
        )
      }}
    >
      <div
        style={{ width: '100%', height: '100%' }}
        onClick={(evt) => {
          evt.stopPropagation()
          selectElement(id)
        }}
        onTouchStart={(evt) => {
          evt.stopPropagation()
          selectElement(id)
        }}
      />
      {isArrow
        ? boxType === 'vArrow' ? <VArrow height={height / factor} realHeight={realHeight} viewQuotes={view && viewQuotes} /> : <HArrow width={width / factor} realWidth={realWidth} viewQuotes={view && viewQuotes} />
        : (
          <div
            className="itemDimension"
            style={{
              bottom: isObstacle ? '0px' : '-20px',
              backgroundColor: isObstacle ? 'rgba(255,255,255,0.9)' : null,
              visibility: view && viewQuotes ? 'visible' : 'hidden',
            }}
          >
            {dimension}
          </div>
        )}
      <div
        style={{
          visibility: isSelected ? 'visible' : 'hidden',
          position: 'absolute',
          top: '4px',
          right: '4px',
          fontSize: '1.4em',
          cursor: 'default',
          lineHeight: '16px',
        }}
        onClick={(evt) => { evt.stopPropagation(); removeElement(id) }}
      >
        <CloseCircleFilled />
      </div>
    </Rnd>
  )
}
